var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 row-gap-4 col-gap-6"},_vm._l((_vm.locations),function(location){return _c('service-status-card',{key:location.id,attrs:{"sub-title":"Location","name":location.name,"percentage":location.percentage,"locationId":location.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }